module.exports = __webpack_public_path__ + "media/Images/derby-affeldt-001-dd45a97e816ad646bb1bb484896d7430.jpg";